import { style } from "@vanilla-extract/css";
import { responsive } from "../../utils";

export const formRowGroupStyle = style({
  ...responsive({
    640: {
      flexDirection: "row",
    },
  }),
  // Keep
  selectors: {
    "&:empty": {
      display: "contents",
    },
  },
});
